export default "/kiban/_next/static/images/30_8L_other-c58614cebb38683286188a3ff2f4075f.png";